import { useMemo } from 'react';
import pick from 'lodash/pick';

export default function useChickenDashboardAvailabilityReqParams(distReqParams) {
  return useMemo(() => {
    if (distReqParams)
      return pick(distReqParams, ['restaurantUuid', 'startTime', 'endTime', 'cookingMethod']);
    else return null;
  }, [distReqParams]);
}
